export default __webpack_public_path__ + "static/media/Thief's Bracers of the Burning Temple.74f7142c.jpg";